export class TemporarySessionStateSetUserIdAndEmail {
  public static readonly type = '[TemporarySession] Set User Id And Email';

  constructor(
    public userId: string,
    public email: string,
  ) {}
}

export class TemporarySessionStateSetIsFirstLogin {
  public static readonly type = '[TemporarySession] Set IsFirstLogin';

  constructor(public isFirstLogin: boolean) {}
}

export class TemporarySessionStateSetMustChangePassword {
  public static readonly type = '[TemporarySession] Set MustChangePassword';

  constructor(public mustChangePassword: boolean) {}
}

export class TemporarySessionStateSetPasswordChangeToken {
  public static readonly type = '[TemporarySession] Set PasswordChangeToken';

  constructor(public passwordChangeToken: string | null) {}
}

export class TemporarySessionStateClear {
  public static readonly type = '[TemporarySession] Clear';
}
